import Model from './Model'

export default class MailsequenceModule extends Model {
    resource() {
        return 'mailsequencemodule'
    }
    
}
